import { Box, Divider } from '@material-ui/core';
import {
  getButtonFromTemplateMessage,
  isTemplateWithFlow,
} from '@src/components/AdminHome/Channels/WhatsApp/WhatsAppFlows/utils';
import RenderMarkdown from '@src/components/RTEditor/RenderMarkdown';
import { TimelineEvent } from '@src/types';
import { useIntl } from 'react-intl';
import ChatMessageWSFlowQuickMessage from './ChatMessageWSFlowQuickMessage';

interface IChatMessageWSFlowTemplate {
  message: Partial<TimelineEvent>;
}

const ChatMessageWSFlowTemplate: React.FC<IChatMessageWSFlowTemplate> = ({
  message,
}) => {
  const { formatMessage } = useIntl();

  const button = getButtonFromTemplateMessage(message as TimelineEvent);
  const buttonText = button?.buttons?.[0].text;
  formatMessage({ id: 'WhatsAppFlow.chatMessage.button.default.text' });

  const body = message?.content?.filter(it => it.type === 'BODY')[0];

  if (message.bodyText && message.flowCta)
    return <ChatMessageWSFlowQuickMessage message={message} />;

  if (!isTemplateWithFlow(message as TimelineEvent))
    return <RenderMarkdown markdown={body?.text} />;

  return (
    <>
      <Box width="100%">
        <Box fontSize="14px" fontWeight={500} width="100%">
          {(message && body?.text) || ''}
        </Box>
        <Divider style={{ marginTop: '7px' }} />
        <Box display="flex" textAlign="center" justifyContent="center">
          <span style={{ color: '#478ECC', marginTop: '12px' }}>
            {buttonText}
          </span>
        </Box>
      </Box>
    </>
  );
};

export default ChatMessageWSFlowTemplate;
